import React from 'react';
import {TabContext,TabList,TabPanel} from '@mui/lab';
import { Grid,Box,Tab } from '@mui/material';
import CommonFAQ from 'components/commonFAQ/CommonFAQ';
import Loader from 'components/loader/Loader';

function FaqTab(props) {
  const {editFaq, deleteFaq,faqLoader,hasViewMoreIcon} = props;

  const handleDeleteFAQ = (props) => {
    deleteFaq(props.id)
   };
   const handleEditFAQ = (props) => {
    editFaq(props)
  };
  
  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={props.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                 className='minHeight32'
                  onChange={props.handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                >
                  <Tab label="Customer" value="Customer" className="tabStyle" />
                  <Tab label="Driver" value="Driver" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="Customer" className="tabPanelStyle">
              {faqLoader ? <Loader/> :
            <CommonFAQ faq={props.FaqData} handleEditFAQ={handleEditFAQ} handleDeleteFAQ={handleDeleteFAQ} hasViewMoreIcon={hasViewMoreIcon} />}
            </TabPanel>
            <TabPanel value="Driver" className="tabPanelStyle">
            {faqLoader ? <Loader/> : 
            <CommonFAQ faq={props.FaqData} handleEditFAQ={handleEditFAQ} handleDeleteFAQ={handleDeleteFAQ} hasViewMoreIcon={hasViewMoreIcon}/>}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FaqTab;
